import React from "react";
import { Header } from "./sections/HeaderView";
import { AppBar } from "../../components/appbar/AppBar";
import { Footer } from "./sections/Footer";
import { Banner } from "./sections/Banner";
import { Faqs } from "./sections/Faqs";
import { Counter } from "./sections/Counter";

export const Landing = () => {
  return (
    <>
      <AppBar />
      <Header />
      <Counter />
      <Faqs />
      <Banner />
      <Footer />
    </>
  );
};
